import React from 'react';
import { withTranslation, WithTranslation, Trans } from 'react-i18next';

import Button from './shared/Button';
import Text from './shared/Typography';
import PageHeader from './shared/PageHeader';
import authService from '../services/auth-service';
import { UserStore } from '../types/user';
import { SignUpAppBanner } from './shared/native-app-banner';

type Props = {
  user: UserStore,
  history: History,
  loading: boolean,
  isOverReqLimit: boolean,
  onClickResendEmail: () => void,
  hasMadeRequests: boolean,
  t: any
}

class OnboardingStateHeader extends React.PureComponent<WithTranslation> {
  state = {
    loading: false,
    resendMessage: {
      type: '',
      text: ''
    }
  }
  props: Props

  resendVerification = (evt: Event): void => {
    evt.preventDefault();
    const { t } = this.props;
    this.setState({ loading: true });
    authService.requestVerifyLink().then(() => {
      this.setState({
        loading: false,
        resendMessage: {
          text: t('resend_success'),
          type: 'success'
        }
      });
    }).catch((error) => {
      this.setState({
        error,
        loading: false,
        resendMessage: {
          text: t('resend_fail'),
          type: 'error'
        }
      });
    });
  }

  render() {
    const { hasMadeRequests, user } = this.props;
    const { t } = this.props;
    const userData = user && user.data;

    // user states
    const userState = userData
      && userData.onboarding_state
      && userData.onboarding_state.state;
    const userStateActions = userData
      && userData.onboarding_state
      && userData.onboarding_state.actions;
    const NOTemailVerified = userState === 'AwaitingVerification'
      || userState === 'AwaitingEmailVerification'
      || (userData && userData.email_verified === false);
    const NOTSubmittedPhotos = userStateActions
      && userStateActions.includes('UploadPhotoID')
      && userState !== 'IDRejected';
    const NOTIDVerified = userState === 'AwaitingIDVerification'
      || (userStateActions
      && userStateActions.includes('AcceptID'));
    const IDRejected = userState
      && userState === 'IDRejected';
    const IDVerified = userState
      && (userState === 'Verified'
      || userState === 'Completed');
    const WildCard = userState === 'UserCreated'
      || (userStateActions
        && userStateActions.includes('SubmitQuestionnaire'
          || 'CreateProfile'
          || 'UploadPhotoIDEarly'));

    // content
    let illustration = null;
    let title = '';
    let message = '';
    const ctaText = null;
    const onClickCTA = null;
    let extraContent = null;

    if (userData && Object.keys(userData).length) {
      title = null;
      message = null;
      const name = this.props.user.data.first_name;
      if (WildCard) {
        illustration = 'illo-id-verification-fail is-small';
        title = t('empty_records_title');
        message = t('not_finished_onboarding');
        extraContent = (
          <Text paragraph align='center'>
            {t('not_onboarded_content')}
          </Text>
        );
      } else if (NOTemailVerified) {
        illustration = 'illo-verify-email is-small';
        title = t('email_verification_title');
        message = t('email_verification_msg');
        extraContent = (
          <div>
            <Text paragraph align='center'>
              <Trans i18nKey='not_verified_content' t={t}>
                <Text span bold>{{ email: this.props.user.data.email }}</Text>
              </Trans>
            </Text>
            <Text paragraph align='center' className='verification__resend-email'>
              {t('resend_verification_email')}
            </Text>
            <div className='is-centered'>
              <Button
                id='resend-email-verification'
                className='btn is-primary'
                onClick={this.resendVerification}
                label={t('resend_verification_label')}
                isLoading={this.state.loading}
              />
            </div>
            <Text paragraph align='center' className={`help-text ${this.state.resendMessage.type}`}>
              {this.state.resendMessage.text}
            </Text>
          </div>
        );
      } else if (IDRejected) {
        illustration = 'illo-id-verification-fail is-small';
        title = t('id_rejected_title');
        message = t('id_rejected_msg');
        extraContent = (
          <Text paragraph align='center'>
            {t('id_rejected_content')}
          </Text>
        );
      } else if (NOTSubmittedPhotos) {
        illustration = 'illo-id-verification-fail is-small';
        title = t('id_rejected_title');
        message = t('no_photos');
        extraContent = (
          <Text paragraph align='center'>
            {t('id_not_submitted_content')}
          </Text>
        );
      } else if (NOTIDVerified) {
        illustration = 'illo-awaiting-id-verification is-small';
        title = t('awaiting_ID_verification_title');
        message = t('awaiting_ID_verification_msg');
      } else if (IDVerified && hasMadeRequests) {
        illustration = 'illo-welcome-desktop';
        title = name ? t('onboarded_title.with_name', { name }) : t('onboarded_title.without_name');
        message = t('awaiting_records_msg');
      } else if (!hasMadeRequests) {
        illustration = 'illo-welcome-desktop';
        title = name ? t('onboarded_title.with_name', { name }) : t('onboarded_title.without_name');
        message = t('empty_records_msg');
        extraContent = (
          <div className='is-center' style={{ width: '50%' }}>
            <SignUpAppBanner text={t('signup_banner')} />
          </div>
        );
      }
    }
    if (title || message || extraContent) {
      return (
        <PageHeader
          className='verification'
          illustrationClass={illustration}
          title={title}
          subtitle={message}
          ctaText={ctaText}
          onClickCTA={onClickCTA}
        >
          {extraContent}
        </PageHeader>
      );
    }
    return '';
  }
}

export default withTranslation('onboardingStateHeader')(OnboardingStateHeader);



// WEBPACK FOOTER //
// ./src/components/onboarding-state-header.js